import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./navbar.css";

import LogoGasometros from "../../assets//images/LogoPNG_WEB-PDLG-01.png";

import { IconType } from "react-icons";
import { FaFacebookSquare, FaInstagram } from "react-icons/fa";


type SocialIconProps = {
  Icon: IconType;
  className?: string;
  size?: number;
};

const SocialIcon = ({ Icon, className }: SocialIconProps) => {
  return <>{Icon({ className })}</>;
};


const NavBar: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  React.useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isMobileMenuOpen]);

  return (
    <header className="sticky top-0 left-0 w-full z-50 bg-white shadow-sm">
      <nav className="navbar">
        {/* Hamburguesa */}
        <button
          className={`menu-btn ${isMobileMenuOpen ? "open" : ""}`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <span className="line" />
          <span className="line" />
          <span className="line" />
        </button>


        {/* Logo centrado */}
        <NavLink to="/" className="navbar-logo" aria-label="Parque de los Gasómetros">
          <img src={LogoGasometros} alt="Parque de los Gasómetros" />
        </NavLink>

        {/* Redes sociales */}
        <div className="navbar-socials">
          <a
            href="https://www.facebook.com/parquedelosgasometros/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <SocialIcon Icon={FaFacebookSquare} />
          </a>

          <a
            href="https://www.instagram.com/parquedelosgasometros/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <SocialIcon Icon={FaInstagram} />
          </a>
        </div>
      </nav>

      <div className={`mobile-menu-overlay ${isMobileMenuOpen ? "open" : ""}`}>
        <NavLink to="/" className="menu-item-pt" end onClick={() => setIsMobileMenuOpen(false)}>Inicio</NavLink>
        <NavLink to="/quienes-somos" onClick={() => setIsMobileMenuOpen(false)}>Quiénes Somos</NavLink>
        <NavLink to="/proyecto" onClick={() => setIsMobileMenuOpen(false)}>Proyecto</NavLink>
        <NavLink to="/nuestra-historia" onClick={() => setIsMobileMenuOpen(false)}>Nuestra Historia</NavLink>
        <NavLink to="/casa-abierta" onClick={() => setIsMobileMenuOpen(false)}>Casa Abierta</NavLink>
        <NavLink to="/nuestro-parque" onClick={() => setIsMobileMenuOpen(false)}>Nuestro Parque</NavLink>
        <NavLink to="/noticias" onClick={() => setIsMobileMenuOpen(false)}>Noticias</NavLink>
        <a href="mailto:contacto@parquedelosgasometros.cl" onClick={() => setIsMobileMenuOpen(false)}>Contacto</a>
        <a
          href="https://www.facebook.com/parquedelosgasometros/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => setIsMobileMenuOpen(false)}
        >
          Facebook
        </a>

        <a
          href="https://www.instagram.com/parquedelosgasometros/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => setIsMobileMenuOpen(false)}
        >
          Instagram
        </a>

        {/* Social Icons */}
        <div className="mobile-menu-socials">
          <a
            href="https://www.facebook.com/parquedelosgasometros/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <SocialIcon Icon={FaFacebookSquare} className="text-lg" />
          </a>
          <a
            href="https://www.instagram.com/parquedelosgasometros/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <SocialIcon Icon={FaInstagram} className="text-lg" />
          </a>
        </div>
      </div>
    </header>
  );
};

export default NavBar;